import { setupFormState } from "../../../form/index.js";
const loginFormInitialValues = { password: "", uid: "", username: "", rememberMe: false };
const loginForm = setupFormState("", {
  id: "loginForm",
  fields: { rememberMe: {}, password: {}, username: {}, uid: {} },
  initialValues: loginFormInitialValues
});
export {
  loginForm,
  loginFormInitialValues
};
//# sourceMappingURL=loginFormSetup.js.map
